import apiClient from "../utils/apiClient";

import { getHeaderKeys } from "../utils/getHeaderKeys";

const headers = ["user-zip"];

const useHttp = () => {
  const getListings = async (query = "") => {
    try {
      const response = await apiClient.get(`listings_v2?${query}`, {
        headers: {
          ...getHeaderKeys(headers),
        },
      });

      return response.data;
    } catch (error) {
      console.error(`🔍 getListings API error:`, error);
      throw error;
    }
  };

  const getGroupListings = async (query = "") => {
    try {
      const response = await apiClient.get(
        `products_v2/products_listings_v2?${query}`,
        {
          headers: {
            ...getHeaderKeys(headers),
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error getting group listings: ", error);
      throw error;
    }
  };

  const getPriceHistory = async (query = "") => {
    try {
      const response = await apiClient.get(`products/price_history?${query}`, {
        headers: {
          ...getHeaderKeys(headers),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error getting products: ", error);
      throw error;
    }
  };

  const getCalPricingHistory = async (query = "") => {
    try {
      const response = await apiClient.get(
        `products/cal_pricing_history?${query}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error getting caliber pricing history: ", error);
      throw error;
    }
  };

  const getProducts = async (query = "") => {
    try {
      const response = await apiClient.get(`products_v2?${query}`, {
        headers: {
          ...getHeaderKeys(headers),
        },
      });

      return response.data;
    } catch (error) {
      console.error(`🔍 getProducts API error:`, error);
      throw error;
    }
  };

  const getCalibers = async () => {
    try {
      const response = await apiClient.get(`/category_calibers`);

      return response.data.response;
    } catch (error) {
      console.error("Error getting calibers: ", error);
      throw error;
    }
  };

  const getBrands = async (brandId = "") => {
    try {
      const response = await apiClient.get(`brand_calibers?brandid=${brandId}`);

      return response.data.response;
    } catch (error) {
      console.error("Error getting brands: ", error);
      throw error;
    }
  };

  const getSearch = async (query = "") => {
    try {
      const response = await apiClient.get(`search${query}`, {
        headers: {
          ...getHeaderKeys(headers),
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error getting products: ", error);
      throw error;
    }
  };

  const getSuggest = async (query = "") => {
    try {
      const response = await apiClient.get(`suggest${query}`, {
        headers: {
          ...getHeaderKeys(headers),
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error getting products: ", error);
      throw error;
    }
  };

  const getCaliberSEO = async (caliber = "") => {
    try {
      const response = await apiClient.get(
        `/seo/caliber_page_seo?seocaliber=${caliber}`,
      );

      return response.data;
    } catch (error) {
      console.error("Error getting caliber SEO:", error);
      throw error;
    }
  };

  const getProductSEO = async (pgid = "") => {
    try {
      const response = await apiClient.get(
        `/seo/product_page_seo?pgid=${pgid}`,
      );

      return response.data;
    } catch (error) {
      console.error("Error getting product SEO: ", error);
      throw error;
    }
  };

  const getBrandSEO = async (brandId = "") => {
    try {
      const response = await apiClient.get(
        `/seo/brand_page_seo?brand=${brandId}`,
      );

      return response.data;
    } catch (error) {
      console.error("Error getting brand SEO: ", error);
      throw error;
    }
  };

  const getBrandCaliberSEO = async (brandId = "", caliber = "") => {
    try {
      const response = await apiClient.get(
        `/seo/brand_caliber_page_seo?brand=${brandId}&caliber=${caliber}`,
      );

      return response.data;
    } catch (error) {
      console.error("Error getting brand SEO: ", error);
      throw error;
    }
  };

  const postMessage = async (data) => {
    try {
      const response = await apiClient.post("/Emails/contact", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return new Promise((resolve) => resolve(response.data));
    } catch (error) {
      console.error("Error getting products: ", error);
      return new Promise((reject) => reject(error));
    }
  };

  const postVendorForm = async (data) => {
    try {
      const response = await apiClient.post("/Emails/register", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return new Promise((resolve) => resolve(response.data));
    } catch (error) {
      console.error("Error submitting vendor form: ", error);
      return new Promise((reject) => reject(error));
    }
  };

  const postNewsLetter = async (data) => {
    try {
      const response = await apiClient.post("/Emails/newsletter", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return new Promise((resolve) => resolve(response.data));
    } catch (error) {
      console.error("Error submitting newsLetter: ", error);
      return new Promise((reject) => reject(error));
    }
  };

  const postProductReport = async (data) => {
    try {
      const response = await apiClient.post("/Emails/report", data);
      return response.data;
    } catch (error) {
      console.error("Error sending product report: ", error);
      throw error;
    }
  };
  const getSiteStatus = async () => {
    try {
      const response = await apiClient.get("/site-status");
      return response.data;
    } catch (error) {
      console.error("Error getting site status: ", error);
      throw error;
    }
  };

  const postSuggestClick = (data) => {
    try {
      fetch(
        "https://ymsvryjc00.execute-api.us-east-1.amazonaws.com/staging/suggest/click",
        {
          method: "POST",
          headers: {
            "x-api-key": "QKAsMnJrNC1vsPwWwBs4cg5VMWBhmc32iq97Yj7a",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
          keepalive: true,
        },
      );
    } catch (error) {
      console.error("Error posting suggest click:", error);
    }
  };

  const getFacetMeta = async () => {
    try {
      const response = await apiClient.get("/facet_meta", {
        headers: {
          "x-api-key": "QKAsMnJrNC1vsPwWwBs4cg5VMWBhmc32iq97Yj7a",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error getting facet_meta: ", error);

      throw error;
    }
  };

  return {
    getListings,
    getCalibers,
    getBrands,
    getSearch,
    getSuggest,
    getCaliberSEO,
    getProductSEO,
    getBrandSEO,
    getBrandCaliberSEO,
    getProducts,
    getGroupListings,
    getPriceHistory,
    getCalPricingHistory,
    postMessage,
    postProductReport,
    postVendorForm,
    postNewsLetter,
    getSiteStatus,
    getFacetMeta,
    postSuggestClick,
  };
};

export default useHttp;
